import PropTypes from 'prop-types';
import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import { pure } from 'recompose';
import cx from 'classnames';

function Loader(props) {
  const loaderClass = cx('loader-wrapper', {
    'loader-wrapper--position_fixed': props.isFixed,
    'loader-wrapper--elevated': props.isElevated,
  });

  return (
    <TransitionGroup>
      <CSSTransition
        classNames="transition-fade"
        timeout={{ enter: 0, exit: 0 }}
      >
        <div className={loaderClass}>
          <div className="loader">
            <div className="sk-child sk-dot1" />
            <div className="sk-child sk-dot2" />
          </div>
          <div className="loader-content">{props.children}</div>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
}

Loader.propTypes = {
  isFixed: PropTypes.bool,
  isElevated: PropTypes.bool,
  children: PropTypes.node,
};

Loader.defaultProps = {
  isFixed: false,
  isElevated: false,
  children: null,
};

export default pure(Loader);
